import React, { useEffect, useState } from 'react';
import HeaderComponent from '../components/headerComponent';
import FooterComponent from '../components/footerComponent';
import { useI18n } from 'react-simple-i18n';
import { useLocation } from 'react-router-dom';
import appstate, { getLocaledString } from '../appstate';
import { ArrowDownComponent } from '../components/arrowDownComponent';

const Kazalo = () => {
	const [titles, setTitles] = useState<string[]>([]);
	const [kazaloOpen, setKazaloOpen] = useState(false);
	const [currentTitle, setCurrentTitle] = useState<string>('');

	const getPrettyTitleFor = (title: string) => {
		if (title === 'MENTORSTVO = PRENOS DOBRIH PRAKS') {
			return 'Mentorstvo';
		}
		if (title === 'MENTORING = TRANSFER OF GOOD PRACTICES') {
			return 'Mentoring';
		}

		if (title.toUpperCase() === 'WHERE CAN I GET HELP?') {
			return 'Where can I get help?';
		}

		if (
			title === 'IZHODIŠČNA TOČKA ORGANIZACIJE?' ||
			title === 'MOJA IZHODIŠČNA TOČKA?'
		) {
			return 'Izhodišče';
		}

		if (title === 'VČASIH POTREBUJEMO MALCE NAVDIHA...') {
			return 'Navdih';
		}
		if (
			title.toLowerCase() === 'sometimes we need a little inspiration...'
		) {
			return 'Inspiration';
		}

		//return lowercase but first letter capitalised
		return title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
	};

	useEffect(() => {
		// get all elements with class is-kazalo-title

		const titles = document.querySelectorAll('.is-kazalo-title');

		if (titles.length === 0) {
			setTitles([]);
			return;
		}

		setTimeout(() => {
			setTitles(
				Array.from(titles).map((title) => {
					return title.textContent || '';
				}),
			);
		}, 1000);
	}, [document.location.pathname]);

	// whenever user scrolls, check if the current title is still the same
	// if not, update the current title
	useEffect(() => {
		const listener = () => {
			// check current scroll position
			const scrollPosition = window.scrollY;

			// get all elements with class is-kazalo-title
			const titles = document.querySelectorAll('.is-kazalo-title');

			if (titles.length === 0) {
				return;
			}

			// get the furthest down title that is still above the scroll position
			let currentTitle = '';
			for (let i = 0; i < titles.length; i++) {
				const title = titles[i];
				const titlePosition =
					title.getBoundingClientRect().top + scrollPosition;

				const offset = 300;
				if (titlePosition > scrollPosition + offset) {
					break;
				}

				currentTitle = title.textContent || '';
			}

			// update the current title
			setCurrentTitle(currentTitle);
		};

		window.addEventListener('scroll', listener);

		return () => {
			window.removeEventListener('scroll', listener);
		};
	}, []);

	const trnstlval1 =
		appstate.currentLanguage() === 'slSI'
			? '-translate-x-40'
			: '-translate-x-12';
	const trnstlval2 =
		appstate.currentLanguage() === 'slSI'
			? '-translate-x-36'
			: '-translate-x-10';

	const trnslt = location.pathname.includes('leaders-in-org')
		? trnstlval1
		: trnstlval2;

	return (
		<div
			className={`fixed left-0 top-24 mt-4 transform transition rounded z-1000 bg-white shadow-lg border border-black/20 ${
				titles && titles.length > 0
					? kazaloOpen
						? '-translate-x-0.5'
						: trnslt
					: '-translate-x-full'
			}`}
			style={{
				background: 'rgb(66, 68, 89)',
				color: 'white',
			}}
		>
			<div
				className={`flex flex-row gap-2 px-4 py-2 cursor-pointer group justify-end font-bold ${
					kazaloOpen ? 'rounded-tr' : 'rounded'
				}`}
				style={{
					paddingRight: kazaloOpen ? '19.1rem' : '1rem',
				}}
				onClick={() => {
					return setKazaloOpen(!kazaloOpen);
				}}
			>
				{getLocaledString('Kazalo', 'Navigation')}
				<div
					className={`w-2.5 h-2.5 mt-2 transform filter invert ${
						kazaloOpen ? 'rotate-0' : '-rotate-90'
					} transition`}
				>
					<ArrowDownComponent />
				</div>
			</div>
			<div
				className={`transform transition-all origin-top h-full overflow-hidden rounded-b cursor-pointer`}
				style={{
					maxHeight: kazaloOpen ? '100vh' : '0px',
				}}
			>
				{titles.map((title, index) => {
					return (
						<div
							key={title}
							className={`p-2 px-4 flex flex-row gap-2 transition-all scale-100 origin-left cursor-pointer hover:translate-x-2 ${
								currentTitle === title && 'font-bold'
							} ${index === titles.length - 1 && 'pb-4'}`}
							onClick={() => {
								// scroll to the title
								const elements =
									document.querySelectorAll(
										`.is-kazalo-title`,
									);

								const titleElement = elements[
									index
								] as HTMLElement | null;

								if (titleElement) {
									titleElement.scrollIntoView({
										behavior: 'smooth',
										block: 'start',
									});
								} else {
									// console.log('title element not found');
								}
							}}
						>
							<div
								className={`w-2.5 h-2.5 mt-2 transform -rotate-90 transition-all capitalize filter invert ${
									currentTitle === title
										? 'ml-0 opacity-100'
										: '-ml-4 opacity-0'
								} transition`}
							>
								<ArrowDownComponent />
							</div>
							{getPrettyTitleFor(title)}
						</div>
					);
				})}
			</div>
		</div>
	);
};

function Intro(props: { hideAnimation: boolean; animationDone: boolean }) {
	const { t } = useI18n();

	const isMd = window.innerWidth < 768;

	// reactive boolean
	const [tick, setTick] = useState(false);

	// tick is a boolean that is set to true after initial render
	useEffect(() => {
		setTick(true);
	}, []);

	return (
		<>
			<div
				className={`fixed w-full top-0 left-0 z-60 transition-all duration-1000 h-screen ${
					props.hideAnimation && 'pointer-events-none'
				}`}
			>
				{/* Background */}
				<div
					className={`w-full h-full opacity-100 bottom-0 masked ${
						props.hideAnimation && 'hide'
					}`}
				>
					{/* Caption */}
					<div className={''}>
						<div
							className={`left-0 z-70 text-accent-200 text-4xl w-screen text-center transition delay-100 duration-500 px-6 md:px-12 ${
								tick
									? props.hideAnimation
										? 'opacity-0'
										: 'opacity-100'
									: 'opacity-0'
							}`}
							style={{
								textAlign: 'center',
								paddingTop:
									document.getElementById('ddt')?.offsetTop +
									'px',
								fontWeight: 'bold',
								// paddingRight: '2.12em',
								position: 'sticky',
								display: 'block',
							}}
						>
							{t('home.caption')}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default function DefaultLayout(props: any) {
	const [hideAnimation, setHideAnimation] = useState(false);
	const { pathname } = useLocation();

	const getIntroDuration = () => {
		const isMobile = window.innerWidth < 1024;

		if (isMobile || pathname !== '/' || appstate.debug) {
			return 100;
		}

		const introPlayDate = localStorage.getItem('introPlayDate');

		if (introPlayDate) {
			// Check if difference between current date and introPlayDate is greater than 1 hour
			const diff =
				new Date().getTime() - new Date(introPlayDate).getTime();
			return diff > 3600000 ? 1500 : 1000;
		}

		return 1300;
	};

	const [noTransform, setNoTransform] = useState(false);

	useEffect(() => {
		// LANGUAGE
		const url = new URL(window.location.href);
		const lang = url.searchParams.get('lang');
		if (lang) {
			if (localStorage.getItem('language') !== lang) {
				localStorage.setItem('language', lang);
				window.location.replace(window.location.href);
			}
		}

		// OTHER
		document.body.classList.add('no-scroll');

		const introDuration = getIntroDuration();

		setTimeout(() => {
			document.body.classList.remove('no-scroll');
			setHideAnimation(true);

			if (introDuration > 0) {
				localStorage.setItem('introPlayDate', new Date().toString());
			}
		}, introDuration);
	}, []);

	useEffect(() => {
		setTimeout(() => {
			setNoTransform(true);
		}, getIntroDuration() * 2);
	});

	// ADD LANGUAGE TO THE URL EVERY TIME THE ROUTE CHANGES
	useEffect(() => {
		const url = new URL(window.location.href);
		url.searchParams.set('lang', appstate.currentLanguage());
		window.history.replaceState({}, '', url.href);
	}, [
		// on route change
		pathname,
	]);

	// layout: max-w-8xl px-6 md:px-12 mx-auto

	return (
		<>
			<Intro animationDone={false} hideAnimation={hideAnimation} />
			<HeaderComponent />
			<div
				className={`flex flex-col ${
					!noTransform && 'transform'
				} origin-top transition duration-700 pt-8`}
			>
				<div className={'flex-1'}>{props.children}</div>
			</div>
			<Kazalo />
			<FooterComponent />
		</>
	);
}
